import CloseIcon from '@mui/icons-material/Close'
import useStyles from './CloseButton.styles'

type Props = {
    onClose: () => void,
}
const CloseButton = ({
    onClose,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()

    return (
        <CloseIcon
            data-testid="close-button"
            role="button"
            className={classes.button}
            onClick={onClose}
        />
    )
}

export default CloseButton
